import { env } from '@/env';
import { setReporter } from '@/services/datadog/reporter';
import { beforeSend, VIEW_NAME } from '@/services/datadog/scrub';

const DEFAULT_SITE = 'datadoghq.com';
const DD_SITES = [
  DEFAULT_SITE,
  'us3.datadoghq.com',
  'us5.datadoghq.com',
  'datadoghq.eu',
  'ddog-gov.com',
  'us2.ddog-gov.com',
  'ap1.datadoghq.com',
  'ap2.datadoghq.com',
] as const;
const SERVICE = 'access-registration';
const SESSION_PERSISTENCE = 'memory';
const PRIVACY_LEVEL = 'mask';

const HALF_CONFIGURED = 'Datadog RUM is off: VITE_DD_APPLICATION_ID and VITE_DD_CLIENT_TOKEN must both be set.';

let initialized = false;

export const initDatadog = async (): Promise<void> => {
  const applicationId = env.DD_APPLICATION_ID?.trim();
  const token = env.DD_CLIENT_TOKEN?.trim();
  if (initialized) return;
  if (!applicationId || !token) {
    if (applicationId || token) console.warn(HALF_CONFIGURED);
    return;
  }
  initialized = true;

  const configuredSite = env.DD_SITE?.trim();
  const site = DD_SITES.find((candidate) => candidate === configuredSite) ?? DEFAULT_SITE;

  const { datadogRum } = await import('@datadog/browser-rum-slim');
  datadogRum.init({
    applicationId,
    clientToken: token,
    site,
    service: SERVICE,
    env: env.MODE,
    version: env.APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    telemetrySampleRate: 0,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    trackViewsManually: true,
    defaultPrivacyLevel: PRIVACY_LEVEL,
    trackAnonymousUser: false,
    sessionPersistence: SESSION_PERSISTENCE,
    beforeSend,
  });
  datadogRum.startView({ name: VIEW_NAME });
  setReporter(datadogRum);
};
